import { render } from "./FishTable.vue?vue&type=template&id=4d9d296a"
import script from "./FishTable.vue?vue&type=script&lang=js"
export * from "./FishTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/acnh-tracker/acnh-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__